"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "screenShareStopped", {
  enumerable: true,
  get: function get() {
    return _screenShareStopped["default"];
  }
});
var _screenShareStopped = _interopRequireDefault(require("./screenShareStopped"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }